import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { DiseñosCurricularesRow } from "./DiseñosCurricularesRow";
import { DiseñoCurricularI } from "interfaces/DiseñoCurricular";
import { DiseniosCurricularesDetailModal } from "../DiseniosCurricularesDetailModal/DiseniosCurricularesDetailModal";

interface Props {
  elementos: DiseñoCurricularI[];
  renderActions?: (
    elemento: DiseñoCurricularI,
    onClickShowDetail: (elemento: DiseñoCurricularI) => void,
  ) => ReactNode;
}

export const DiseñosCurricularesTable = ({
  elementos = [],
  renderActions,
}: Props) => {
  const [selectedElement, setSelectedElement] =
    useState<DiseñoCurricularI | null>(null);
  const [showModal, setShowModal] = useState(false);
  const onShowDetailModal = (elemento: DiseñoCurricularI) => {
    console.log("se ejectua");
    setSelectedElement(elemento);
    setShowModal(true);
  };

  const onCloseDetailModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedElement(null);
    }, 400);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Descripción</th>
            <th>Fecha publicación</th>
            <th>Estado</th>
            <th>Nivel</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <DiseñosCurricularesRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={
                  renderActions
                    ? (e) => renderActions(e, onShowDetailModal)
                    : undefined
                }
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 7 : 7}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay diseños curriculares para visualizar.</b> Para poder
                  visualizar diseños curriculares debes <br /> seleccionar el
                  botón agregar «Nuevo diseño curricular».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <DiseniosCurricularesDetailModal
        elemento={selectedElement}
        showModal={showModal}
        onClose={onCloseDetailModal}
      ></DiseniosCurricularesDetailModal>
    </>
  );
};
